import { render, staticRenderFns } from "./IntegralGoodsList.vue?vue&type=template&id=75560b51&"
import script from "./IntegralGoodsList.vue?vue&type=script&lang=js&"
export * from "./IntegralGoodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports